import { Pipe } from '@angular/core';

@Pipe({
  name: "trocarDeVirgulaParaPonto"
})
export class ReplaceCaractere {

  transform(value: string): string {

     return value ? value.toString().replace('.',',') : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/replaceCaractere.pipe.ts